export const TEMPLATE_PLACEHOLDER_LINK = 'withjoy.com/name-and-name';
export const HANDWRITING_GUIDE_LINE_LAYER_NAME = 'handwritingGuideLine';
// Postcard back templates tag their return-address layer with this so joy-web can find it (modal edit + structured render).
export const RETURN_ADDRESS_LAYER_NAME = 'returnAddress';
